import { isNodeList } from "./isNodeList";
import { hasClass } from './hasClass';

/**
 * 给元素添加类名
 * 
 * 此函数用于给指定的DOM元素添加一个或多个类名。如果类名已存在，则不会重复添加。
 * 
 * @param el 要操作的DOM元素
 * @param str 要添加的类名，可以是单个类名或多个类名组成的字符串
 * @returns 返回操作的DOM元素
 */
const _addClass = (el: Element, str: string) => {
  // 检查元素是否已具有该类名，如果没有则添加
  str.trim().split(/\s+/).forEach(item => {
    if (!hasClass(el, item)) { el.classList.add(item); }
  });
};

export const addClass = (els: any, str: string) => {
  if (!els) return;
  els = typeof (els) === 'string' ? document.querySelectorAll(els) : (isNodeList(els) || els instanceof Array) ? els : [els];

  els.forEach((item: any) => {
  str.trim().split(/\s+/).forEach(className => {
    if (!hasClass(item, className)) { item.classList.add(className); }
  });
});
  
};